define([
  "backbone",
  "jquery",
  "underscore",
  "configuration/properties",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, _, Properties, Messenger, SortableListModel) {
  "use strict";

  const RefreshTokensModel = {};

  RefreshTokensModel.refreshToken = Backbone.Model.extend({
    defaults: function () {
      return {
        clientId: "",
        expiresAt: null,
        revoked: false,
        token: "",
        userId: 0,
      };
    },
    url: function () {
      if (this.id) {
        return Properties.rootURL + "/user/refreshTokens/" + this.id;
      }
      return Properties.rootURL + "/user/refreshTokens";
    },
  });

  RefreshTokensModel.refreshTokens = Backbone.Collection.extend({
    model: RefreshTokensModel.refreshToken,
    url: function () {
      return Properties.rootURL + "/user/refreshTokens";
    },
  });

  Messenger.reqres.setHandler("refreshTokens:headers", function () {
    return new SortableListModel.headerCollection([
      {
        headerName: $.t("user.refreshToken.token"),
        modelAttribute: "token",
        selectable: true,
        sortable: true,
        filterable: true,
        longTextField: true,
        width: "50%",
        customHtml:
          "<% if (token) { %>" +
          '<a href="#" class="refresh-token-show">' +
          '<%- token.substring(0, 40) + "..." + token.substring(token.length - 40) %>' +
          "</a>" +
          "<% } %>",
      },
      {
        headerName: $.t("user.refreshToken.expiresAt"),
        modelAttribute: "expiresAt",
        defaultSort: true,
        sortable: true,
        filterable: true,
        dateField: true,
        width: "20%",
      },
      {
        headerName: $.t("user.refreshToken.revoked"),
        modelAttribute: "revoked",
        booleanField: true,
        booleanFieldCheck: true,
        filterable: true,
        width: "10%",
      },
      {
        headerName: "",
        width: "20%",
        customHtml:
          '<button type="button" class="btn btn-link refresh-token-copy"' +
          ' data-i18n="[title]user.refreshToken.copyToken" data-toggle="tooltip">' +
          '<i class="icon-copy"></i></button>' +
          "<% if (!revoked) { %>" +
          '<button type="button" class="btn btn-link refresh-token-revoke"' +
          ' data-i18n="[title]user.refreshToken.revoke" data-toggle="tooltip">' +
          '<i class="icon-remove"></i></button>' +
          "<% } %>",
      },
    ]);
  });

  return RefreshTokensModel;
});
